import { Box, Divider, Grid, Typography } from '@mui/material';
import { fileUrl } from 'api/api';
import ProductFormatsApi from 'api/setting/default-products/product-format.api';
import ProductInstructionsApi from 'api/setting/default-products/product-instruction.api';
import ProductPreservesApi from 'api/setting/default-products/product-preserve.api';
import ProductTypesApi from 'api/setting/default-products/product-type.api';
import ProductUnitsApi from 'api/setting/default-products/product-unit.api';
import ProductUsesApi from 'api/setting/default-products/product-use.api';
import MedicinesApi from 'api/warehouses/medicine.api';
import ButtonCustom from 'component/Button/ButtonCustom';
import HeaderLabel from 'component/CardCustom/HeaderLabel';
import { notiSuccess } from 'component/notifications/notifications';
import { icons, imgs } from 'constants/images';
import { colors } from 'constants/theme';
import $ from 'jquery';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { routeName } from 'routes/routes-name';

/** TRANSLATION*/
import { useTranslation } from 'react-i18next';

/** STYLE */
import { UploadImage } from 'features/warehouses/medicines/style';
import _ from 'lodash';
import { checkAddons, checkPackage, numberOnly } from 'utils/app.utils';
import { PACKAGE_ADDONS } from 'constants/package';

import ProductWarningsApi from 'api/setting/default-products/product-warning.api';
import barcodeExam from 'assets/images/warehouse/barcode-exam.png';
import FucntionPrint from 'component/Print/print';
import AutocompleteSelect from 'component/Select/AutocompleteSelect';
import CheckboxButton from 'new-components/buttons/checkbox-button';
import SwitchButton from 'new-components/buttons/switch-button';
import TextAreaInput from 'new-components/inputs/text-area-input';
import TextInput from 'new-components/inputs/text-input';
import Barcode from 'react-barcode';

type RawFileType = {
  fileId?: number | null
  base64?: string | null
  fileName?: string | null
  fileExtension?: string | null
  fileSize?: string | null
}

const initStateErrorMessage = {
  PRODUCT_CODE: ``,
  PRODUCT_NAME: ``,
  PRODUCT_NAME_EN: ``,
  PRODUCT_TYPE_ID: ``,
  PRODUCT_FORMAT_ID: ``,
  PRODUCT_UNIT_ID: ``,
  SALE_PRICE: ``,
  COST_PRICE: ``,
  MIN_STOCK: ``,
  COMPLETE_BARCODE: ``,
  IS_DUPLICATE_MEDICINE_BARCODE: ``,
  MIN_SALE_PRICE: ``,
  MAX_SALE_PRICE: ``,
  MIN_SALE_PRICE_RANGE: ``,
  MAX_SALE_PRICE_RANGE: ``,
  MAX_SALE_PRICE_ZERO: ``
}

export default function FormMedicines() {
  const { t } = useTranslation()
  const { id }: any = useParams()
  const [productTypes, setProductTypes]: any = useState([])
  const [productFormats, setProductFormats] = useState([])
  const [productUnits, setProductUnits] = useState([])
  const [productUses, setProductUses] = useState([])
  const [productInstructions, setProductInstructions] = useState([])
  const [productPreserves, setProductPreserves] = useState([])
  const [productWarningsOption, setProductWarningsOption] = useState([])
  const [productId, setProductId] = useState(Number)
  const [productCode, setProductCode] = useState('')
  const [productName, setProductName] = useState('')
  const [productNameEn, setProductNameEn] = useState('')
  const [productTypeId, setProductTypeId] = useState<number | null>(null)
  const [productFormatId, setProductFormatId] = useState<number | null>(null)
  const [productUnitId, setProductUnitId] = useState<number | null>(null)
  const [productInstructionId, setProductInstructionId] = useState<number | null>(null)
  const [productPreserveId, setProductPreserveId] = useState<number | null>(null)
  const [productUseId, setProductUseId] = useState<number | null>(null)
  const [productWarningId, setProductWarningId] = useState<number | null>(null)
  const [strength, setStrength] = useState('')
  const [salePrice, setSalePrice] = useState<any>('')
  const [costPrice, setCostPrice] = useState<any>('')
  const [minSalePrice, setMinSalePrice] = useState<any>('')
  const [maxSalePrice, setMaxSalePrice] = useState<any>('')
  const [isPriceRange, setIsPriceRange] = useState<'0' | '1'>('0')
  const [minStock, setMinStock] = useState<any>('')
  const [explanation, setExplanation] = useState('')
  const [showOnReceipt, setShowOnReceipt] = useState(`SHOW`)
  const [statusProduct, setStatusProduct] = useState(`ACTIVE`)
  const [warnings, setWarnings] = useState('');
  const [amounDayBeforeExpired, setAmounDayBeforeExpired] = useState<any>('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [numberBarcode, setNumberBarcode] = useState<string>('')
  const [isRequiredDispense, setIsRequiredDispense] = useState<'0' | '1'>('0')

  const [files, setFiles] = useState<RawFileType[]>([])

  const [image, setImage] = useState({
    fileId: null,
    base64: '',
    fileExtension: '',
    fileSize: ''
  })

  const [defaultProductType, setDefaultProductType] = useState({ label: ``, value: `` })
  const [defaultProductFormat, setDefaultProductFormat] = useState({ label: ``, value: `` })
  const [defaultProductUnit, setDefaultProductUnit] = useState({ label: ``, value: `` })
  const [defaultProductInstruction, setDefaultProductInstruction] = useState({ label: ``, value: `` })
  const [defaultProductPreserve, setDefaultProductPreserve] = useState({ label: ``, value: `` })
  const [defaultProductUse, setDefaultProductUse] = useState({ label: ``, value: `` })
  const [defaultProductWarning, setDefaultProductWarning] = useState({ label: ``, value: `` })

  const [imgData, setImgData]: any = useState()
  const [filesData, setFilesData]: any = useState([])

  const [errorMessage, setErrorMessage]: any = useState(initStateErrorMessage)
  const submittingRef = useRef(false)
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const loadData = useCallback(async () => {
    loadProductTypes()
    loadProductFormats()
    loadProductUnits()
    loadProductInstructions()
    loadProductPreserves()
    loadProductUses()
    loadProductWarnings()
  }, [])

  useEffect(() => {
    loadData()
    if (id !== undefined) loadProductById()
  }, [loadData])

  const loadProductTypes = async (search = null) => {
    let condition: any = { group: 'MEDICINE', pageLimit: 50, status: 'ACTIVE' }
    if (search) condition = { ...condition, search: search }
    const res = await ProductTypesApi.findAll(condition)
    if (res.status === 200) {
      const newData = res.data.map((value: any) => {
        return { label: value.productTypeName, value: value.productTypeId }
      })
      setProductTypes(newData)
    }
  }

  const loadProductFormats = async (search = null) => {
    let condition: any = { group: 'MEDICINE', pageLimit: 50, status: 'ACTIVE' }
    if (search) condition = { ...condition, search: search }
    const res = await ProductFormatsApi.findAll(condition)
    if (res.status === 200) {
      const newData = res.data.map((value: any) => {
        return { label: value.productFormatName, value: value.productFormatId }
      })
      setProductFormats(newData)
    }
  }

  const loadProductUnits = async (search = null) => {
    let condition: any = { group: 'MEDICINE', pageLimit: 50, status: 'ACTIVE' }
    if (search) condition = { ...condition, search: search }
    const res = await ProductUnitsApi.findAll(condition)
    if (res.status === 200) {
      const newData = res.data.map((value: any) => {
        return { label: value.productUnitName, value: value.productUnitId }
      })
      setProductUnits(newData)
    }
  }

  const loadProductInstructions = async (search = null) => {
    let condition: any = { group: 'MEDICINE', pageLimit: 50, status: 'ACTIVE' }
    if (search) condition = { ...condition, search: search }
    const res = await ProductInstructionsApi.findAll(condition)
    if (res.status === 200) {
      const newData = res.data.map((value: any) => {
        return { label: value.productInstructionName, value: value.productInstructionId }
      })
      setProductInstructions(newData)
    }
  }

  const loadProductPreserves = async (search = null) => {
    let condition: any = { group: 'MEDICINE', pageLimit: 50, status: 'ACTIVE' }
    if (search) condition = { ...condition, search: search }
    const res = await ProductPreservesApi.findAll(condition)
    if (res.status === 200) {
      const newData = res.data.map((value: any) => {
        return { label: value.productPreserveName, value: value.productPreserveId }
      })
      setProductPreserves(newData)
    }
  }

  const loadProductUses = async (search = null) => {
    let condition: any = { group: 'MEDICINE', pageLimit: 50, status: 'ACTIVE' }
    if (search) condition = { ...condition, search: search }
    const res = await ProductUsesApi.findAll(condition)
    if (res.status === 200) {
      const newData = res.data.map((value: any) => {
        return { label: value.productUseDetail, value: value.productUseId }
      })
      setProductUses(newData)
    }
  }

  const loadProductWarnings = async (search = null) => {
    let condition: any = { group: 'MEDICINE', pageLimit: 50, status: 'ACTIVE' }
    if (search) condition = { ...condition, search: search }
    const res = await ProductWarningsApi.getProductWarning(condition)
    if (res.status === 200) {
      const newData = res.data.map((value: any) => {
        return { label: value.productWarningName, value: value.productWarningId }
      })
      setProductWarningsOption(newData)
    }
  }

  const loadProductById = async () => {
    const { status, data }: any = await MedicinesApi.findById(id)
    if (status === 200) {
      setProductId(data.productId)
      setProductCode(data.productCode)
      setProductName(data.productName)
      setProductNameEn(data.productNameEn)
      setProductTypeId(data.productTypeId)
      setProductFormatId(data.productFormatId)
      setProductUnitId(data.productUnitId)
      setProductInstructionId(data.productInstructionId)
      setProductWarningId(data.productWarningId)
      setProductPreserveId(data.productPreserveId)
      setProductUseId(data.productUseId)
      setStrength(data.strength)
      setSalePrice(data.salePrice)
      setCostPrice(data.costPrice)
      setMinSalePrice(data.minSalePrice !== null && data.minSalePrice !== undefined ? String(data.minSalePrice) : '')
      setMaxSalePrice(data.maxSalePrice !== null && data.maxSalePrice !== undefined ? String(data.maxSalePrice) : '')
      setIsPriceRange(data.isPriceRange || '0')
      setMinStock(data.minStock)
      setExplanation(data.explanation)
      setShowOnReceipt(data.showOnReceipt)
      setStatusProduct(data.status)
      setWarnings(data.warnings)
      setAmounDayBeforeExpired(data.amounDayBeforeExpired)
      setNumberBarcode(data?.numberBarcode || '')
      setIsRequiredDispense(data?.isRequiredDispense || '0')

      if (data.image) {
        setImgData(`${fileUrl}/${data.image.filePath}/${data.image.fileName}`)
        setImage({ fileId: data.image.fileId, base64: '', fileExtension: '', fileSize: '' })
      }
      if (data.files) {
        const fileArray = []
        const rawFiles = []
        for (const index in data.files) {
          const file = data.files[index]
          rawFiles.push({
            fileId: file.fileId,
            base64: '',
            fileName: file.fileName,
            fileExtension: '',
            fileSize: ''
          })
          fileArray.push({ fileName: `${file?.fileName || '-'}`, filePathFull: `${fileUrl}/${file.filePath}/${file.fileName}` })
        }
        setFiles(rawFiles)
        setFilesData(fileArray)
      }
      if (data.productType) setDefaultProductType({ label: data.productType.productTypeName, value: data.productType.productTypeId })
      if (data.productFormat) setDefaultProductFormat({ label: data.productFormat.productFormatName, value: data.productFormat.productFormatId })
      if (data.productUnit) setDefaultProductUnit({ label: data.productUnit.productUnitName, value: data.productUnit.productUnitId })
      if (data.productInstruction) setDefaultProductInstruction({ label: data.productInstruction.productInstructionName, value: data.productInstruction.productInstructionId })
      if (data.productPreserve) setDefaultProductPreserve({ label: data.productPreserve.productPreserveName, value: data.productPreserve.productPreserveId })
      if (data.productUse) setDefaultProductUse({ label: data.productUse.productUseDetail, value: data.productUse.productUseId })
      if (data.productWarning) setDefaultProductWarning({ label: data.productWarning.productWarningName, value: data.productWarning.productWarningId })
    }
  }

  const submit = async () => {
    if (submittingRef.current) return
    // 2) ตี lock + บล็อคปุ่ม UI
    submittingRef.current = true
    setIsSubmitting(true)

    let unlockOnEnd = true

    // validation
    const validationErrors: any = {
      PRODUCT_NAME: !productName ? t(`MEDICINE.MESSAGE.ERROR.NONE_MEDICINE_NAME`) : '',
      PRODUCT_CODE: !productCode ? t(`MEDICINE.MESSAGE.ERROR.NONE_MEDICINE_CODE`) : '',
      PRODUCT_TYPE_ID: !productTypeId ? t(`MEDICINE.MESSAGE.ERROR.NONE_MEDICINE_TYPE`) : '',
      COST_PRICE: costPrice === '' ? t(`MEDICINE.MESSAGE.ERROR.NONE_FUND`) : '',
      SALE_PRICE: salePrice === '' ? t(`MEDICINE.MESSAGE.ERROR.NONE_PRICE`) : '',
      MIN_STOCK: minStock === '' ? t(`MEDICINE.MESSAGE.ERROR.NONE_STOCK`) : '',
      COMPLETE_BARCODE: (numberBarcode.length > 0 && numberBarcode.length < 13) ? t(`MEDICINE.MESSAGE.ERROR.COMPLETE_BARCODE`) : '',
      MIN_SALE_PRICE: '',
      MAX_SALE_PRICE: '',
      MAX_SALE_PRICE_RANGE: '',
      MAX_SALE_PRICE_ZERO: ''
    }

    // Validation for price range
    if (isPriceRange === '1') {
      const minPrice = Number(minSalePrice) || 0
      const maxPrice = Number(maxSalePrice) || 0
      const salePriceNum = Number(salePrice) || 0

      if (!minSalePrice || minSalePrice === '') {
        validationErrors.MIN_SALE_PRICE = t('MEDICINE.MESSAGE.ERROR.MIN_SALE_PRICE')
      }
      if (!maxSalePrice || maxSalePrice === '') {
        validationErrors.MAX_SALE_PRICE = t('MEDICINE.MESSAGE.ERROR.MAX_SALE_PRICE')
      } else if (maxSalePrice === '0' || maxPrice === 0) {
        validationErrors.MAX_SALE_PRICE_ZERO = t('MEDICINE.MESSAGE.ERROR.MAX_SALE_PRICE_ZERO')
      }

      // Only do numeric/range comparisons when all inputs are present.
      if (minSalePrice && maxSalePrice && salePrice) {
        // maxPrice ต้องมากกว่าหรือเท่ากับ minPrice
        if (maxPrice < minPrice) {
          validationErrors.MAX_SALE_PRICE_RANGE = t('MEDICINE.MESSAGE.ERROR.MAX_SALE_PRICE_RANGE')
        }

        // minSalePrice ห้ามมากกว่า salePrice
        if (minPrice > salePriceNum) {
          validationErrors.MIN_SALE_PRICE = t('MEDICINE.MESSAGE.ERROR.MIN_SALE_PRICE_RANGE')
        }

        // maxSalePrice ห้ามน้อยกว่า salePrice
        if (maxPrice < salePriceNum) {
          validationErrors.MAX_SALE_PRICE_RANGE = t('MEDICINE.MESSAGE.ERROR.MAX_SALE_PRICE_RANGE')
        }
      }
    }

    // Check if there are any validation errors
    const hasValidationError = Object.values(validationErrors).some((error: any) => error !== '')
    if (hasValidationError) {
      setErrorMessage({ ...errorMessage, ...validationErrors })
      submittingRef.current = false
      setIsSubmitting(false)
      return
    }
    const objCreate = {
      group: 'MEDICINE',
      productCode,
      productName,
      productNameEn,
      productTypeId,
      productFormatId,
      productUnitId,
      productInstructionId,
      productPreserveId,
      productUseId,
      productWarningId,
      strength,
      salePrice: Number(salePrice),
      costPrice: Number(costPrice),
      minSalePrice: minSalePrice ? Number(minSalePrice) : null,
      maxSalePrice: maxSalePrice ? Number(maxSalePrice) : null,
      isPriceRange: isPriceRange,
      minStock: Number(minStock),
      explanation,
      showOnReceipt,
      files,
      image,
      warnings,
      amounDayBeforeExpired: Number(amounDayBeforeExpired),
      numberBarcode,
      isRequiredDispense: checkAddons(PACKAGE_ADDONS.ADDON_ALERT_NO_MEDICINE) ? isRequiredDispense : '0'
    };
    try {
      const res: any = await MedicinesApi.create(objCreate);
      if (res.status === 201) {
        unlockOnEnd = false
        notiSuccess(t(`MEDICINE.MESSAGE.SUCCESS.ADD_MEDICINE`));
        setTimeout(() => { window.location.href = routeName.medicine }, 800);
      } else {
        const err = res.response?.data;
        setErrorMessage({ ...errorMessage, [err.message]: t(`MEDICINE.MESSAGE.ERROR.ERROR_AGAIN`) });
      }
    } catch (e: any) {
      const msg = e.response?.data?.message;
      if (msg === 'IS_DUPLICATE_MEDICINE_NAME') {
        setErrorMessage({ ...errorMessage, [msg]: t(`MEDICINE.MESSAGE.ERROR.IS_DUPLICATE_MEDICINE_NAME`) });
      } else if (msg === 'IS_DUPLICATE_MEDICINE_NAME_EN') {
        setErrorMessage({ ...errorMessage, [msg]: t(`MEDICINE.MESSAGE.ERROR.IS_DUPLICATE_MEDICINE_NAME_EN`) });
      } else if (msg === 'IS_DUPLICATE_MEDICINE_BARCODE') {
        setErrorMessage({ ...errorMessage, [msg]: t(`MEDICINE.MESSAGE.ERROR.IS_DUPLICATE_MEDICINE_BARCODE`) });
      } else {
        setErrorMessage({ ...errorMessage, [msg]: t(`MEDICINE.MESSAGE.ERROR.MEDICINE_DUP`) });
      }
    } finally {
      if (unlockOnEnd) {
        submittingRef.current = false
        setIsSubmitting(false)
      }
    }
  };
  const submitUpdate = async () => {
    if (submittingRef.current) return
    // 2) ตี lock + บล็อคปุ่ม UI
    submittingRef.current = true
    setIsSubmitting(true)

    let unlockOnEnd = true

    // validation
    const validationErrors: any = {
      PRODUCT_NAME: !productName ? t(`MEDICINE.MESSAGE.ERROR.NONE_MEDICINE_NAME`) : '',
      PRODUCT_CODE: !productCode ? t(`MEDICINE.MESSAGE.ERROR.NONE_MEDICINE_CODE`) : '',
      PRODUCT_TYPE_ID: !productTypeId ? t(`MEDICINE.MESSAGE.ERROR.NONE_MEDICINE_TYPE`) : '',
      COST_PRICE: costPrice === '' ? t(`MEDICINE.MESSAGE.ERROR.NONE_FUND`) : '',
      SALE_PRICE: salePrice === '' ? t(`MEDICINE.MESSAGE.ERROR.NONE_PRICE`) : '',
      MIN_STOCK: minStock === '' ? t(`MEDICINE.MESSAGE.ERROR.NONE_STOCK`) : '',
      COMPLETE_BARCODE: (numberBarcode.length > 0 && numberBarcode.length < 13) ? t(`MEDICINE.MESSAGE.ERROR.COMPLETE_BARCODE`) : '',
      MIN_SALE_PRICE: '',
      MAX_SALE_PRICE: '',
      MAX_SALE_PRICE_RANGE: '',
      MAX_SALE_PRICE_ZERO: ''
    }

    // Validation for price range
    if (isPriceRange === '1') {
      const minPrice = Number(minSalePrice) || 0
      const maxPrice = Number(maxSalePrice) || 0
      const salePriceNum = Number(salePrice) || 0

      if (!minSalePrice || minSalePrice === '') {
        validationErrors.MIN_SALE_PRICE = t('MEDICINE.MESSAGE.ERROR.MIN_SALE_PRICE')
      }
      if (!maxSalePrice || maxSalePrice === '') {
        validationErrors.MAX_SALE_PRICE = t('MEDICINE.MESSAGE.ERROR.MAX_SALE_PRICE')
      } else if (maxSalePrice === '0' || maxPrice === 0) {
        validationErrors.MAX_SALE_PRICE_ZERO = t('MEDICINE.MESSAGE.ERROR.MAX_SALE_PRICE_ZERO')
      }

      // Only do numeric/range comparisons when all inputs are present.
      if (minSalePrice && maxSalePrice && salePrice) {
        // maxPrice ต้องมากกว่าหรือเท่ากับ minPrice
        if (maxPrice < minPrice) {
          validationErrors.MAX_SALE_PRICE_RANGE = t('MEDICINE.MESSAGE.ERROR.MAX_SALE_PRICE_RANGE')
        }

        // minSalePrice ห้ามมากกว่า salePrice
        if (minPrice > salePriceNum) {
          validationErrors.MIN_SALE_PRICE = t('MEDICINE.MESSAGE.ERROR.MIN_SALE_PRICE_RANGE')
        }

        // maxSalePrice ห้ามน้อยกว่า salePrice
        if (maxPrice < salePriceNum) {
          validationErrors.MAX_SALE_PRICE_RANGE = t('MEDICINE.MESSAGE.ERROR.MAX_SALE_PRICE_RANGE')
        }
      }
    }

    // Check if there are any validation errors
    const hasValidationError = Object.values(validationErrors).some((error: any) => error !== '')
    if (hasValidationError) {
      setErrorMessage({ ...errorMessage, ...validationErrors })
      submittingRef.current = false
      setIsSubmitting(false)
      return
    }
    const objUpdate = {
      group: 'MEDICINE',
      productCode,
      productName,
      productNameEn,
      productTypeId,
      productFormatId,
      productUnitId,
      productInstructionId,
      productPreserveId,
      productUseId,
      productWarningId,
      strength,
      salePrice: Number(salePrice),
      costPrice: Number(costPrice),
      minSalePrice: minSalePrice ? Number(minSalePrice) : null,
      maxSalePrice: maxSalePrice ? Number(maxSalePrice) : null,
      isPriceRange: isPriceRange,
      minStock: Number(minStock),
      explanation,
      showOnReceipt,
      status: statusProduct,
      files,
      image,
      warnings,
      amounDayBeforeExpired: Number(amounDayBeforeExpired),
      numberBarcode,
      isRequiredDispense: checkAddons(PACKAGE_ADDONS.ADDON_ALERT_NO_MEDICINE) ? isRequiredDispense : '0'
    };

    try {
      const res: any = await MedicinesApi.update(productId, objUpdate);
      if (res.status === 200) {
        unlockOnEnd = false
        notiSuccess(t(`MEDICINE.MESSAGE.SUCCESS.EDIT_MEDICINE`));
        setTimeout(() => { window.location.href = routeName.medicine }, 800);
      } else {
        const err = res?.response.data
        setErrorMessage({ ...errorMessage, [err.message]: t(`MEDICINE.MESSAGE.ERROR.ERROR_AGAIN`) });
      }
    } catch (e: any) {
      const msg = e.response?.data?.message;
      if (msg === 'IS_DUPLICATE_MEDICINE_NAME') {
        setErrorMessage({ ...errorMessage, [msg]: t(`MEDICINE.MESSAGE.ERROR.IS_DUPLICATE_MEDICINE_NAME`) });
      } else if (msg === 'IS_DUPLICATE_MEDICINE_NAME_EN') {
        setErrorMessage({ ...errorMessage, [msg]: t(`MEDICINE.MESSAGE.ERROR.IS_DUPLICATE_MEDICINE_NAME_EN`) });
      } else if (msg === 'IS_DUPLICATE_MEDICINE_BARCODE') {
        setErrorMessage({ ...errorMessage, [msg]: t(`MEDICINE.MESSAGE.ERROR.IS_DUPLICATE_MEDICINE_BARCODE`) });
      } else {
        setErrorMessage({ ...errorMessage, [msg]: t(`MEDICINE.MESSAGE.ERROR.MEDICINE_DUP`) });
      }
    } finally {
      if (unlockOnEnd) {
        submittingRef.current = false
        setIsSubmitting(false)
      }
    }
  };



  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const onChangePicture = (e: any) => {
    if (e.target.files[0]) {
      const file = e.target.files[0]

      const fileName = file.name.split('.')
      const detailImage = {
        fileId: null,
        base64: '',
        fileExtension: fileName[fileName.length - 1],
        fileSize: file.size.toString()
      }
      const reader: any = new FileReader()
      reader.addEventListener('load', () => {
        const base64 = reader.result.split(',')
        setImgData(reader.result)
        detailImage.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result
      })
      reader.readAsDataURL(file)
      setImage(detailImage)
    }
  }
  const onChangeFiles = (e: any) => {
    if (e.target.files != null) {
      /**
       * e.target.files all detail file
       * lastModified, lastModifiedDate
       * name, size, type
       */
      const rawFiles: any = []
      const fileNames: any = []

      for (let index = 0; index < e.target.files.length; index++) {
        const file = e.target.files[index]
        fileNames.push({ fileName: file.name, filePathFull: null })
        const fileName = file.name.split('.')
        const detailFile = {
          fileId: null,
          base64: '',
          fileExtension: fileName[fileName.length - 1],
          fileName: file.name,
          fileSize: file.size.toString()
        }
        const reader: any = new FileReader()
        reader.addEventListener('load', () => {
          /** reader.result is base64 */
          const base64 = reader.result.split(',')
          detailFile.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result
        })
        reader.readAsDataURL(file)
        rawFiles.push(detailFile)
      }

      setFiles([...files, ...rawFiles])
      setFilesData([...filesData, ...fileNames])
    }
  }

  const hendlerDeleteFile = (refId: number) => {
    if (fileInputRef.current) { fileInputRef.current.value = ""; }
    setFiles(_.filter(files, (fs, indexFs: number) => indexFs !== refId))
    setFilesData(_.filter(filesData, (fd, indexFd: number) => indexFd !== refId))
  }

  const handleShowOnReceipt = () => {
    setShowOnReceipt(showOnReceipt === 'SHOW' ? 'HIDE' : 'SHOW')
    clearErrorMessage()
    setSalePrice(0)
  }
  return (
    <Box height="100%" sx={{ overflow: 'hidden' }}>
      <Box height="100%" display="flex" flexDirection="column">
        <HeaderLabel
          text={productId ? t('MEDICINE.HEADER.TITLE_EDIT') : t('MEDICINE.HEADER.TITLE_ADD')}
          navigator={{ previousTo: routeName.medicine, previousTitle: t('MEDICINE.HEADER.TITLE'), currentTitle: productId ? t('MEDICINE.HEADER.TITLE_EDIT') : t('MEDICINE.HEADER.TITLE_ADD') }}
          goBack={routeName.medicine}
          onSubmit={productId ? submitUpdate : submit}
          disabled={isSubmitting}
        />

        <Box border="1px solid" borderColor={colors.lightGray} boxShadow={1} mx={3} mb={3} height="100%" overflow="hidden" borderRadius={'8px'} bgcolor="#fff">
          <Box height="100%" py={0} pl={2} pr={3} overflow="auto" display="flex" flexDirection="column" >
            <Box className="overflow-auto w-100" sx={{ overflow: { lg: 'hidden !important' }, maxHeight: { lg: 'unset !important' } }} style={{ maxHeight: '100%' }}>
              <Grid container spacing={2} className="pl-3 pl-lg-0 mt-0 h-100 flex-column flex-xl-row flex-nowrap">
                <Grid item lg={2} className="p-3 w-100 d-flex flex-column" sx={{ borderRight: { lg: `1px solid ${colors.lightGray}` }, maxHeight: '100%' }}>
                  <UploadImage
                    className={`align-content-center flex-center mx-auto mb-3`}
                    onClick={() => {
                      $('#profilePic').click()
                    }}
                  >
                    <Box className='image-wrap'>
                      <Box className="d-none">
                        <input id="profilePic" type="file" accept=".jpeg, .jpg, .png, .webp" onChange={onChangePicture} />
                      </Box>
                      {imgData ? (
                        <img className={`image-preview  w-100 h-100`} alt="" src={imgData} />
                      ) : (
                        <Box className={'upload-image text-center w-100 h-100 d-flex flex-column align-items-center justify-content-center'}>
                          <img src={imgs.defaultAddImage} alt="uploadImage" />
                          <Typography className={'pt-1 pt-sm-2 m-0'}>{t('REGISTER.UPLOAD_TREATMENT.UPLOAD_IMAGE')}</Typography>
                        </Box>
                      )}
                    </Box>
                  </UploadImage>
                  {productId ? (
                    <Box mt={2}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
                        <SwitchButton onChange={() => setStatusProduct(statusProduct === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={statusProduct === 'ACTIVE' ? true : false} />
                      </Box>
                      <Divider sx={{ my: 2, backgroundColor: 'transparent', borderColor: `${colors.darkGray} !important`, width: '108%', transform: 'translateX(-40px)' }} />
                    </Box>
                  ) : (
                    ''
                  )}
                  <Box className='overflow-auto custom-scroll'>
                    <Typography className='m-0' style={{ fontWeight: 500 }}>{t('MEDICINE.FORM.DOCUMENT_INFO')}</Typography>
                    <Box className="mt-1">
                      <Box className="d-none">
                        <input id="uploadFiles" multiple type="file" accept=".pdf" onChange={onChangeFiles} ref={fileInputRef} />
                      </Box>
                      <ButtonCustom
                        variant="text"
                        textButton={t('MEDICINE.FORM.ADD_DOCUMENT')}
                        onClick={() => {
                          $('#uploadFiles').click()
                        }}
                        btnStyle={{ fontSize: 16 }}
                      />
                    </Box>
                    {filesData &&
                      filesData.map((file: any, i: number) => (
                        <Box key={i} className="d-flex align-items-center overflow-hidden">
                          <label
                            htmlFor={`contained-button-file-${i}`}
                            className={`d-flex align-items-center mr-3 text-ellipsis  ${file.filePathFull ? 'cursor-pointer' : ''}`}
                            onClick={() => file.filePathFull && window.open(file.filePathFull)}>
                            <img src={icons.attachmentLine} alt="" className={'mr-2'} />
                            <span className='text-ellipsis' style={{ textDecoration: file.filePathFull ? 'underline' : 'none' }}>{file.fileName.split('?')[0]}</span>
                          </label>
                          <img src={icons.trashOutlined} onClick={(e) => hendlerDeleteFile(i)} alt="" className="cursor-pointer ml-auto" />
                        </Box>
                      ))}
                  </Box>
                </Grid>
                <Grid item lg={10} className={'pl-0 pl-lg-3 py-3 w-100 h-100 overflow-hidden d-flex flex-column'}>
                  <div className='d-flex flex-column overflow-auto custom-scroll'>
                    <Grid container spacing={2}>
                      <Grid item xs={6} md={4} className="w-100">
                        <Box className='mt-2'>
                          <TextInput
                            onChange={(event) => {
                              clearErrorMessage()
                              setProductName(event.target.value)
                            }}
                            label={t("MEDICINE.FORM.MEDICINE_NAME")}
                            value={productName}
                            key={`product-name`}
                            inputProps={{ maxLength: 255 }}
                            required={true}
                            fullWidth
                            helperText={errorMessage.PRODUCT_NAME || errorMessage.IS_DUPLICATE_MEDICINE_NAME || errorMessage.PRODUCT_NAME_STRING_BASE || errorMessage.PRODUCT_NAME_MAXIMUM_LENGTH || errorMessage.PRODUCT_NAME_STRING_EMPTY || errorMessage.PRODUCT_NAME_ANY_REQUIRED}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={6} md={4} className="w-100">
                        <Box className='mt-2'>
                          <TextInput
                            onChange={(event) => {
                              clearErrorMessage()
                              setProductNameEn(event.target.value)
                            }}
                            label={t("MEDICINE.FORM.MEDICINE_NAME_ENG")}
                            value={productNameEn}
                            key={`product-name-en`}
                            inputProps={{ maxLength: 255 }}
                            required={false}
                            fullWidth
                            helperText={errorMessage.PRODUCT_NAME_EN || errorMessage.IS_DUPLICATE_MEDICINE_NAME_EN || errorMessage.PRODUCT_NAME_EN_STRING_BASE || errorMessage.PRODUCT_NAME_EN_MAXIMUM_LENGTH || errorMessage.PRODUCT_NAME_EN_STRING_EMPTY || errorMessage.PRODUCT_NAME_EN_ANY_REQUIRED}
                          />
                        </Box>
                      </Grid>
                      <Grid item className="w-100">
                        <div className='ml-1'>
                          <CheckboxButton onChange={handleShowOnReceipt} checked={showOnReceipt === 'SHOW' ? true : false} label={t(`MEDICINE.FORM.SHOW_ON_RECEIPT`)} />
                        </div>
                      </Grid>
                      {checkAddons(PACKAGE_ADDONS.ADDON_ALERT_NO_MEDICINE) && (
                        <Grid item className="w-100">
                          <Box className='ml-1'>
                            <CheckboxButton
                              onChange={() => setIsRequiredDispense(isRequiredDispense === '0' ? '1' : '0')}
                              checked={isRequiredDispense === '1'}
                              label={t(`MEDICINE.FORM.IS_REQUIRED_DISPENSE`)}
                            />
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                    <Grid container spacing={2} className="mt-0">
                      <Grid item className="w-100">
                        <Divider className="m-0" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                      </Grid>
                      <Grid item className="w-100">
                        <Typography className='m-0' style={{ fontSize: 18, fontWeight: 500 }}>{t('MEDICINE.FORM.MEDICINE_DETAIL')}</Typography>
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <TextInput
                          onChange={(event) => {
                            clearErrorMessage()
                            setProductCode(event.target.value)
                          }}
                          label={t('MEDICINE.FORM.MEDICINE_CODE')}
                          value={productCode}
                          key={`product-code`}
                          inputProps={{ maxLength: 20 }}
                          required={true}
                          fullWidth
                          helperText={errorMessage.PRODUCT_CODE || errorMessage.IS_DUPLICATE_MEDICINE_CODE || errorMessage.PRODUCT_CODE_STRING_BASE || errorMessage.PRODUCT_CODE_MAXIMUM_LENGTH || errorMessage.PRODUCT_CODE_STRING_EMPTY || errorMessage.PRODUCT_CODE_ANY_REQUIRED}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} sx={{ width: '100%' }}>
                        <AutocompleteSelect
                          labelId="product-type"
                          inputLabel={t('MEDICINE.FORM.MEDICINE_TYPE')}
                          options={productTypes}
                          onchange={(e, val) => {
                            clearErrorMessage()
                            setProductTypeId(val?.value || 0)
                            setDefaultProductType({ label: val?.label || ``, value: val?.value || `` })
                          }}
                          onInputChange={(event: any, newValue: any) => loadProductTypes(newValue)}
                          value={defaultProductType}
                          errMessage={errorMessage.PRODUCT_TYPE_ID}
                          required
                          disableClearable={!productTypeId}
                        />
                      </Grid>

                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <TextInput
                          onChange={(event) => {
                            clearErrorMessage()
                            setStrength(event.target.value)
                          }}
                          label={t('MEDICINE.FORM.STRENGTH')}
                          value={strength}
                          key={`strength`}
                          inputProps={{ maxLength: 100 }}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} sx={{ width: '100%' }}>
                        <AutocompleteSelect

                          labelId="product-unit"
                          inputLabel={t('MEDICINE.FORM.MEDICINE_UNIT')}
                          options={productUnits}
                          onchange={(e, val) => {
                            clearErrorMessage()
                            setProductUnitId(val?.value || 0)
                            setDefaultProductUnit({ label: val?.label || ``, value: val?.value || `` })
                          }}
                          onInputChange={(event: any, newValue: any) => loadProductUnits(newValue)}
                          value={defaultProductUnit}
                          disableClearable={!productUnitId}
                          params={{
                            ListboxProps: {
                              sx: {
                                maxHeight: '200px'
                              }
                            }
                          }}
                        // errMessage={errorMessage.PRODUCT_UNIT_ID}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} sx={{ width: '100%' }}>
                        <AutocompleteSelect
                          labelId="product-instruction"
                          inputLabel={t('MEDICINE.FORM.MEDICINE_HOWTO')}
                          options={productInstructions}
                          getOptionLabel={(option: any) => option.label}
                          onchange={(e, val) => {
                            setProductInstructionId(val?.value || 0)
                            setDefaultProductInstruction({ label: val?.label || ``, value: val?.value || `` })
                            clearErrorMessage()
                          }}
                          onInputChange={(event: any, newValue: any) => loadProductInstructions(newValue)}
                          value={defaultProductInstruction}
                          disableClearable={!productInstructionId}
                          params={{
                            ListboxProps: {
                              sx: {
                                maxHeight: '200px'
                              }
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} sx={{ width: '100%' }}>
                        <AutocompleteSelect
                          labelId="product-use"
                          inputLabel={t('MEDICINE.FORM.MEDICINE_USETIME')}
                          options={productUses}
                          onchange={(e, val) => {
                            setProductUseId(val?.value || 0)
                            setDefaultProductUse({ label: val?.label || ``, value: val?.value || `` })
                            clearErrorMessage()
                          }}
                          onInputChange={(event: any, newValue: any) => loadProductUses(newValue)}
                          value={defaultProductUse}
                          disableClearable={!productUseId}
                          params={{
                            ListboxProps: {
                              sx: {
                                maxHeight: '200px'
                              }
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} sx={{ width: '100%' }}>
                        <AutocompleteSelect
                          labelId="product-instruction"
                          inputLabel={t('MEDICINE.FORM.WARNING')}
                          options={productWarningsOption}
                          getOptionLabel={(option: any) => option.label}
                          onchange={(e, val) => {
                            setProductWarningId(val?.value || 0)
                            setDefaultProductWarning({ label: val?.label || ``, value: val?.value || `` })
                            clearErrorMessage()
                          }}
                          onInputChange={(event: any, newValue: any) => loadProductWarnings(newValue)}
                          value={defaultProductWarning}
                          disableClearable={!productWarningId}
                          params={{
                            ListboxProps: {
                              sx: {
                                maxHeight: '200px'
                              }
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} sx={{ width: '100%' }}>
                        <AutocompleteSelect
                          labelId="product-preserve"
                          inputLabel={t('MEDICINE.FORM.PRODUCT_PRESERVES')}
                          options={productPreserves}
                          getOptionLabel={(option: any) => option.label}
                          onchange={(e, val) => {
                            setProductPreserveId(val?.value || 0)
                            setDefaultProductPreserve({ label: val?.label || ``, value: val?.value || `` })
                            clearErrorMessage()
                          }}
                          onInputChange={(event: any, newValue: any) => loadProductPreserves(newValue)}
                          value={defaultProductPreserve}
                          disableClearable={!productPreserveId}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} sx={{ width: '100%' }}>
                        <AutocompleteSelect
                          labelId="product-format"
                          inputLabel={t('MEDICINE.FORM.PRODUCT_FORMATS')}
                          options={productFormats}
                          onchange={(e, val) => {
                            clearErrorMessage()
                            setProductFormatId(val?.value || 0)
                            setDefaultProductFormat({ label: val?.label || ``, value: val?.value || `` })
                          }}
                          onInputChange={(event: any, newValue: any) => loadProductFormats(newValue)}
                          value={defaultProductFormat}
                          // errMessage={errorMessage.PRODUCT_FORMAT_ID}
                          disableClearable={!productFormatId}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <TextInput
                          onChange={(event) => {
                            clearErrorMessage()
                            setCostPrice(numberOnly(event))
                          }}
                          label={t('MEDICINE.FORM.PRODUCT_FUND')}
                          value={costPrice}
                          key={`cost-price`}
                          inputProps={{ maxLength: 12 }}
                          required={true}
                          helperText={errorMessage['COST_PRICE']}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <TextInput
                          disabled={showOnReceipt === "HIDE" ? true : false}
                          onChange={(event) => {
                            clearErrorMessage()
                            setSalePrice(numberOnly(event))
                          }}
                          label={t('MEDICINE.FORM.PRODUCT_PRICE')}
                          value={salePrice}
                          key={`sale-price`}
                          inputProps={{ maxLength: 12 }}
                          required={true}
                          helperText={errorMessage.SALE_PRICE}
                          marginBottomErrorText='16px'
                          fullWidth
                        />
                      </Grid>
                      {checkAddons(PACKAGE_ADDONS.ADDON_PRICE_RANGE) && (
                      <Grid item sm={12} className="w-100">
                        <Grid container flexDirection="row" alignItems="start" gap="16px">
                          <CheckboxButton
                            checked={isPriceRange === '1'}
                            label={t('MEDICINE.FORM.ENABLE_PRICE_RANGE') || 'เปิดใช้งานราคาช่วง'}
                            onChange={() => {
                              setIsPriceRange(isPriceRange === '0' ? '1' : '0')
                              setMinSalePrice('')
                              setMaxSalePrice('')
                              clearErrorMessage()
                            }}
                          />
                          {isPriceRange === '1' && (
                            <Grid item xs={6} md={4} lg={3} className="w-100">
                              <TextInput
                                onChange={(event) => {
                                  clearErrorMessage()
                                  const raw = numberOnly(event)
                                  const [intPart] = raw.split('.')
                                  if (intPart.length <= 6) {
                                    setMinSalePrice(raw)
                                  }
                                }}
                                label={t('MEDICINE.FORM.MIN_SALE_PRICE') || 'ราคาขายขั้นต่ำ'}
                                value={minSalePrice}
                                key={`min-sale-price`}
                                helperText={
                                  errorMessage.MIN_SALE_PRICE ||
                                  errorMessage.MIN_SALE_PRICE_RANGE ||
                                  (isPriceRange === '1' && minSalePrice && salePrice && Number(salePrice) < Number(minSalePrice) ? t('MEDICINE.MESSAGE.ERROR.SALE_PRICE_RANGE') : '')
                                }
                                fullWidth
                                marginBottomErrorText='16px'
                              />
                            </Grid>
                          )}
                          {isPriceRange === '1' && (
                            <Grid item xs={6} md={4} lg={3} className="w-100">
                              <TextInput
                                onChange={(event) => {
                                  clearErrorMessage()
                                  const raw = numberOnly(event)
                                  const [intPart] = raw.split('.')
                                  if (intPart.length <= 6) {
                                    setMaxSalePrice(raw)
                                  }
                                }}
                                label={t('MEDICINE.FORM.MAX_SALE_PRICE') || 'ราคาขายขั้นสูงสุด'}
                                value={maxSalePrice}
                                key={`max-sale-price`}
                                helperText={
                                  errorMessage.MAX_SALE_PRICE ||
                                  errorMessage.MAX_SALE_PRICE_ZERO ||
                                  errorMessage.MAX_SALE_PRICE_RANGE ||
                                  (isPriceRange === '1' && maxSalePrice && salePrice && Number(salePrice) > Number(maxSalePrice) ? t('MEDICINE.MESSAGE.ERROR.SALE_PRICE_RANGE') : '')
                                }
                                fullWidth
                                marginBottomErrorText='16px'
                              />
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                      )}
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <TextInput
                          onChange={(event) => {
                            clearErrorMessage()
                            setMinStock(numberOnly(event))
                          }}
                          label={t('MEDICINE.FORM.MINSTOCK')}
                          value={minStock}
                          key={`min-stock`}
                          required={true}
                          inputProps={{ maxLength: 11 }}
                          helperText={errorMessage['MIN_STOCK']}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <TextInput
                          onChange={(event) => {
                            const value = numberOnly(event)
                            setAmounDayBeforeExpired(value.length >= 2 ? value.slice(0, 2) : value)
                            clearErrorMessage()
                          }}
                          inputProps={{ maxLength: 2 }}
                          label={t('MEDICINE.FORM.EXPIRED')}
                          value={amounDayBeforeExpired}
                          key={`expired`}
                          fullWidth
                        />
                      </Grid>
                      <Grid item className="w-100">
                        <TextAreaInput
                          onChange={(event) => {
                            clearErrorMessage()
                            const inputValue = event.target.value;
                            setExplanation(inputValue)
                          }}
                          value={explanation}
                          label={t('MEDICINE.FORM.EXPLANATION')}
                          helperText=""
                          fullWidth
                        />
                      </Grid>
                      <Grid item className="w-100">
                        <FormProductBarcode
                          helperTextError={errorMessage.IS_DUPLICATE_MEDICINE_BARCODE || (numberBarcode.length === 0 || numberBarcode.length === 13 ? '' : errorMessage['COMPLETE_BARCODE'])}
                          valueBarcode={numberBarcode}
                          onChange={(event) => {
                            clearErrorMessage()
                            const inputValue = event.target.value;
                            const regex = /^[0-9]{0,13}$/;
                            if (regex.test(inputValue)) {
                              setNumberBarcode(inputValue);
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export type FormProductBarcodeProps = {
  valueBarcode: string
  onChange: (event: any) => void
  helperTextError: string;
}


export const FormProductBarcode = (props: FormProductBarcodeProps) => {
  const { t } = useTranslation()
  const [size, setSize] = useState({ w: 300, h: 142 })
  const [labelNumberBarcode, setLabelNumberBarcode] = useState<string>('LABEL')
  const barcodeRef = useRef<any>(null)

  useEffect(() => {
    if (props.valueBarcode !== '') {
      setLabelNumberBarcode('')
      setSize({
        w: barcodeRef.current.clientWidth,
        h: barcodeRef.current.clientHeight,
      })
    }
  }, [props.valueBarcode])

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
        <Box sx={{ fontSize: '18px', fontWeight: '500' }}>
          {t('MEDICINE.FORM.DETAIL_BARCODE')}
        </Box>
        <Box>
          <FucntionPrint
            content={() => barcodeRef.current}
            removeIfram
            trigger={() => <ButtonCustom textButton={t('MEDICINE.FORM.PRINT_BARCODE')} variant={'outlined'} disabled={(!props.valueBarcode || props.valueBarcode === "")} />}
            style={`
              @page { 
                  size:  ${barcodeRef?.current && barcodeRef.current?.clientWidth ? barcodeRef.current?.clientWidth : 300}px 162px; 
                  margin: none; padding: none; 
              } 
              @media print {  html, body { -webkit-print-color-adjust: exact; margin: none; padding: none; }`}
          />

        </Box>
      </Box>
      <Box sx={{ minWidth: '300px', maxWidth: 'fit-content', padding: '16px', border: `1px solid ${colors.lightGray}` }}>
        <Box marginBottom={1}>
          <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${props.valueBarcode.length}/${13}`}</Box>
          <TextInput
            placeholder={''}
            label={t(`MEDICINE.FORM.${labelNumberBarcode}NUMBERBARCODE`)}
            value={props.valueBarcode}
            key={``}
            onChange={props.onChange}
            inputProps={{ maxLength: 13 }}
            helperText={props.helperTextError}
            fullWidth
          />
        </Box>
        <Box sx={{ overflowX: 'auto', display: 'flex', justifyContent: 'center', overflowY: 'hidden', height: '142px' }}>
          {props.valueBarcode && props.valueBarcode !== "" ?
            <Box ref={barcodeRef} sx={{ width: 'fit-content' }}> <Barcode value={props.valueBarcode} format="CODE128" /> </Box>
            : <Box sx={{ height: '142px' }}><img src={barcodeExam} alt="barcode" style={{ width: '153px' }} /></Box>
          }
        </Box>
      </Box>
    </>
  )
}
